import { z } from 'zod';
import { adminEntityCursorSchema } from '../const/adminEntityCursorSchema';

export const getAdminEntitySchema = z.object({
    limit: z.number().int().min(1).max(100).default(20),
    search: z.string().trim().optional().nullable(),
    cursor: adminEntityCursorSchema.optional().nullable(),
});

export type GetAdminEntitySchema = z.infer<typeof getAdminEntitySchema>;
